"use strict";
"use client";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactAria = require("react-aria");
var _reactAriaComponents = require("react-aria-components");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Tooltip = exports.Tooltip = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var _children$props$class;
  var _ref$opened = _ref.opened,
    opened = _ref$opened === void 0 ? false : _ref$opened,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? "bottom" : _ref$placement,
    content = _ref.content,
    children = _ref.children,
    disabled = _ref.disabled,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    wrapperClassname = _ref.wrapperClassname,
    arrowClassname = _ref.arrowClassname,
    contentClassName = _ref.contentClassName,
    _ref$isReverseColor = _ref.isReverseColor,
    isReverseColor = _ref$isReverseColor === void 0 ? false : _ref$isReverseColor,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 10 : _ref$offset;
  var directionStyles = (0, _react.useMemo)(function () {
    var primaryDirection = placement.split(" ")[0];
    switch (primaryDirection) {
      case "left":
        return "-ml-1";
      case "right":
        return "-mr-1";
      case "top":
        return "-my-1";
      case "bottom":
      default:
        return "-my-1";
    }
  }, [placement]);
  if (disabled || !children) {
    return children;
  }
  var isFullWidth = /*#__PURE__*/(0, _react.isValidElement)(children) && (((_children$props$class = children.props.className) === null || _children$props$class === void 0 ? void 0 : _children$props$class.includes("w-full")) || children.props.fullWidth);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactAriaComponents.TooltipTrigger, {
    defaultOpen: opened,
    delay: 0,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactAriaComponents.Focusable, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        role: "button",
        tabIndex: 0,
        "data-testid": "tooltip-trigger",
        className: (0, _classnames["default"])("focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50", _defineProperty({
          "inline-block w-full": isFullWidth
        }, "".concat(wrapperClassname), !!wrapperClassname)),
        children: children
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactAriaComponents.Tooltip, {
      offset: offset,
      placement: placement,
      "data-testid": "tooltip-content",
      className: (0, _classnames["default"])("p-2 rounded-md text-xs", isReverseColor ? "bg-base-100 text-base-content" : "bg-base-content text-base-100", _defineProperty({}, "".concat(contentClassName), !!contentClassName)),
      style: style,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactAriaComponents.OverlayArrow, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          "data-testid": "tooltip-arrow",
          className: (0, _classnames["default"])("w-[8px] h-[8px] rotate-45", directionStyles, isReverseColor ? "bg-base-100" : "bg-base-content", _defineProperty({}, "".concat(arrowClassname), !!arrowClassname))
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactAria.FocusScope, {
        contain: true,
        restoreFocus: true,
        children: content
      })]
    })]
  });
});